import {createContext} from "react";

// This context stores the current stack for the given position.
const StackContext = createContext();

export default StackContext;
